import { Component, AfterViewInit, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FormControl,FormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements AfterViewInit, OnInit {
  submit = false;
  isSubmitted = false;
  myFormSubmit = false;

  constructor(private fb: FormBuilder,public shared: SharedService,private apiService: ApiServiceService){
    this.shared.isWhiteMenu = true;
  }
  contactForm = new FormGroup({
    name : new FormControl ('',[Validators.required]),
    email : new FormControl ('',[Validators.required]),
    subject : new FormControl ('',[Validators.required]),
    message : new FormControl ('',[Validators.required]),
  });

  ngOnInit(): void {
      
  }
  
  ngAfterViewInit(): void {
      this.shared.includeMainScript();
  }
  
  async submitForm() {
    this.myFormSubmit = true;
    console.log(this.contactForm.value);
  
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CONTACT_US, this.contactForm.value);
  
    if (res && !res.error) {
      this.isSubmitted = true;
    } else {
      console.error("Error submitting the form:", res);
    }
  }
  
  onSubmit() {
    this.submitForm();
  }
  
}
